import React, { useMemo } from "react";
import PrivateRoute from "components/Route/PrivateRoute";
import { MenuConfig } from "./RouteConfig";
import { Redirect, Switch } from "react-router-dom";
import { ROUTE_PAGE } from "./RoutePage";

export default function GenerateRoute() {
  const getRuta = useMemo(() => {
    const ruta = [];
    for (let index = 0; index < MenuConfig.length; index++) {
      const mn = MenuConfig[index];
      if (mn.link && mn.component) {
        ruta.push(
          <PrivateRoute
            key={index + "r1"}
            exact
            component={mn.component}
            path={mn.link}
          ></PrivateRoute>
        );
      }
      if (mn.subMenu && mn.subMenu?.length > 0) {
        for (let idx = 0; idx < mn.subMenu.length; idx++) {
          const subItem = mn.subMenu[idx];
          if (subItem.link && subItem.component) {
            ruta.push(
              <PrivateRoute
                key={index + "r4" + idx}
                exact
                component={subItem.component}
                path={subItem.link}
              ></PrivateRoute>
            );
          }
        }
      }

      if (mn.pages && mn.pages?.length > 0) {
        for (let idx = 0; idx < mn.pages.length; idx++) {
          const subPage = mn.pages[idx];
          if (subPage.link && subPage.component) {
            ruta.push(
              <PrivateRoute
                key={index + "r2" + idx}
                exact
                component={subPage.component}
                path={subPage.link}
              ></PrivateRoute>
            );
          }
        }
      }
    }
    return ruta;
  }, []);
  return <Switch>
      {getRuta}
      <Redirect to={ROUTE_PAGE.AUTH.LOGIN} />
  </Switch>;
}
